import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function BusinessFooter({ children }:Props) {
    return (
        <Container>
            <Text as='div' size='s' color={colors.gray7} css={css`
                white-space: pre-wrap;
            `}>
                {children}
            </Text>
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    background-color: ${colors.gray1};
    padding: 16px 20px 48px;
    margin-top: 24px;
`;

export default BusinessFooter;
